import { useTranslation } from 'react-i18next'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { RemoteContent, Title } from '@jupi/ui'
import { useAtisStations } from '../../api/atis'
import { AtisCard } from '../../components/atis/AtisCard'

export default function AtisPage() {
  const { t } = useTranslation()
  const { data: stations = [], isLoading, error } = useAtisStations()
  return (
    <Box>
      <Title label={t('atis.title')} />
      <Alert severity="info" sx={{ mb: 2 }}>
        {t('atis.intro')}
      </Alert>
      <RemoteContent isLoading={isLoading} error={error}>
        <Grid container spacing={2}>
          {stations.map((station) => (
            <Grid key={station.icao} size={{ xs: 12, lg: 6 }}>
              <AtisCard icao={station.icao} />
            </Grid>
          ))}
        </Grid>
      </RemoteContent>
    </Box>
  )
}
